import { AxiosPromise } from 'axios';
import { libAuthInstance } from '../axios';
import { CreateAccountRequest } from './types/createAccountRequest';

export function requestCreateAccount(
    data: CreateAccountRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libAuthInstance.post('/createaccount', data, { signal });
}
